import { combineReducers } from "redux";
import { createItemReducer, createItemReducerParams } from "@mnjsplatform/data/lib/reducers/dataItemReducer";

export function subMedicalPolicyReducer() {
    return combineReducers({
        EmployeesMedicalPolicy_ListSubForPO: createItemReducer("SubMedicalPolicy", "PersMedInsure.ListSubForNewPO", false),
        EmployeesMedicalPolicy_ListSubForPOParams: createItemReducerParams("SubMedicalPolicy", "PersMedInsure.ListSubForNewPO")
    });
}